<template>
  <v-card :loading="getStatusMetricsLoading" class="metrics">

    <v-card-title>Statuses</v-card-title>

    <template v-if="!getStatusMetricsLoading">
      <v-card-text class="px-11 px-xl-15 pb-4">
        <div class="d-flex flex-column mb-4">
          <div class="d-flex flex-wrap mb-4 metrics__row">
            <StatusCard :statusData="getStatusMetrics['01 UDD']" colour="success" />
            <StatusCard :statusData="getStatusMetrics['Bad Debt']" colour="success" />
            <StatusCard :statusData="getStatusMetrics['Blocked Bad Debt']" colour="warning" />
            <StatusCard :statusData="getStatusMetrics['Pending Cease Bad Debt']" colour="warning" />
          </div>
          <div class="d-flex flex-wrap metrics__row">
            <StatusCard :statusData="getStatusMetrics['Dead 01 UDD']" colour="error" />
            <StatusCard :statusData="getStatusMetrics['Handed Over']" colour="error" />
            <StatusCard :statusData="getStatusMetrics['Write Off']" colour="error" />
            <StatusCard :statusData="getStatusMetrics['Written Off']" colour="error" />
            <StatusCard :statusData="getStatusMetrics['Dead Bad Debt']" colour="error" />
          </div>
        </div>

        <div class="d-flex flex-wrap justify-start align-center metrics__row">
          <StatusCard :statusData="getStatusMetrics['No Comms']" colour="primary" :column="false" />
          <StatusCard :statusData="getStatusMetrics['Excluded']" colour="primary" :column="false" />
        </div>
      </v-card-text>
    </template>

  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  
  import StatusCard from './StatusCard';

  export default {
    components: { StatusCard },

    computed: {
      ...mapGetters('creditControlDashboard', ['getStatusMetrics', 'getStatusMetricsLoading'])
    },

    created() {
      this.fetchStatusMetrics();
    },

    methods: {
      ...mapActions('creditControlDashboard', ['fetchStatusMetrics'])
    }
  }
</script>

<style lang="scss" scoped>
  .metrics__row {
    row-gap: 16px !important;
    column-gap: 16px !important;
  }
</style>